import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const ApplicationWrap = styled.div`
  height: 100vh;
  max-width: 100vw;
`

export const GlobalStyles = css`
  body {
    margin: 0;
  }
`
